<script setup lang="ts">
import type { AppCamperSearch } from '@yescapa-dev/ysc-api-js/modern'

interface Props {
  campers: AppCamperSearch[]
  dateFrom?: string
  dateTo?: string
}

withDefaults(defineProps<Props>(), {
  dateFrom: undefined,
  dateTo: undefined,
})

defineEmits<{
  'map-change': [{
    cords: {
      lat: number | null
      lng: number | null
    }
    radius: number
    center: {
      lat: number
      lng: number
    }
  }]
  'marker-click': [AppCamperSearch]
  'search-in-area': []
  'toggle-map': []
  'wishlist': [AppCamperSearch]
}>()

const { markedItem } = storeToRefs(useSearchStore())
</script>

<template>
  <div>
    <YscMap
      class="h-full w-screen lg:w-full"
      :max-zoom="16"
      is-draggable
      :products="campers"
      :show-satellite="false"
      @input="$emit('map-change', $event)"
      @marker-click="$emit('marker-click', $event)"
    />
    <button
      id="search-in-area"
      class="absolute left-0 right-0 top-0 z-[9] mx-auto mt-4 w-max rounded-lg bg-white px-6 py-2 text-black transition hover:bg-black hover:text-white"
      @click="$emit('search-in-area')"
    >
      {{ $t('components.app_search.search_in_area') }}
    </button>
    <AppSearchMapToggleButton
      v-if="!markedItem"
      class="fixed bottom-0 left-0 right-0 z-20 mx-auto mb-4 flex lg:hidden"
      @toggle="$emit('toggle-map')"
    >
      <YscIconsList class="mr-1 inline h-6 w-6" /> {{ $t('components.app_search.display_list') }}
    </AppSearchMapToggleButton>
    <div
      v-if="markedItem"
      class="absolute bottom-4 left-0 z-[9] hidden w-full items-center justify-center p-2 md:flex md:px-0"
    >
      <AppSearchCamperMapCard
        :camper="markedItem"
        :date-from="dateFrom"
        :date-to="dateTo"
        @wishlist="$emit('wishlist', $event)"
      />
    </div>
  </div>
</template>
